import { useModalStore } from 'src/stores/ModalStore';

export default function ModalRenderer() {
  const modalTitle = useModalStore((state)=>state.title)
  const modalContent = useModalStore((state)=>state.content)
  const modalFooter = useModalStore((state)=>state.footer)

  return (
    <>
      {modalTitle}
      {modalContent}
      {modalFooter}
    </>
  );
}